import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import FilterInputItem from '../../../../molecules/FilterInputItem';
export function Text({ name, filters, setFilter }) {
    const { t } = useTranslation();
    return (_jsx(FilterInputItem, { name: name, label: t(`dossier.filters.${name}.label`), placeholder: t(`dossier.filters.${name}.placeholder`), value: filters[name] || '', setFilter: setFilter(name) }));
}
